import { render, staticRenderFns } from "./DeleteProcessStatusRules.vue?vue&type=template&id=31180848"
import script from "./DeleteProcessStatusRules.vue?vue&type=script&lang=js"
export * from "./DeleteProcessStatusRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports